module.exports = __webpack_public_path__ + "static/fighter-04-d358c4d30e7138a6a0293311269786a1.png";